export default "__VITE_ASSET__DKRCUPoz__"